export const login_i18n = {
  // Alts
  bannerAlt: "fondo de inicio de sesión",
  brandAlt: "WA Checkin",
  footerLogoAlt: "WA Checkin",
  togglePasswordAria: "mostrar u ocultar contraseña",

  // Panel de marca de la pantalla de acceso. Frase corta y concreta:
  // dice lo que hace el producto, no lo bien que lo hace.
  panelKicker: "WACheckin · 2026",
  panelCta: "Conoce WACheckin",
  partnersLabel: "Conectado con",
  // Las tarjetas de la escena del panel.
  escena: {
    reservas: "Reservas",
    mensajes: "Mensajes automáticos",
    llaves: "Llaves digitales",
    checkin: "Check-in online",
    cobros: "Cobros automatizados",
    autoridades: "Autoridades y cumplimiento",
  },

  // Paso 2: el código que llega al correo.
  verify: {
    title: "Revisa tu correo",
    titleWhatsapp: "Revisa tu WhatsApp",
    sending: "Enviando…",
    destinoWhatsapp: "Te llegará al",
    destinoCorreo: "Te llegará a",
    intro: "Te hemos enviado un código de {largo} dígitos a",
    submit: "Entrar",
    submitting: "Comprobando...",
    back: "Usar otra cuenta",
    resendAsk: "¿No te llega?",
    resend: "Reenviar código",
    resendWait: "Reenviar en {s} s",
    resendDone: "Te hemos enviado un código nuevo.",
    expires: "El código caduca en {tiempo}",
    expired: "El código ha caducado. Pide uno nuevo.",
    digitAria: "Dígito {n} de {total}",
    otroMetodo: "¿No te llega el correo?",
    porWhatsapp: "Recíbelo por WhatsApp",
    preferesCorreo: "¿Prefieres el correo?",
    porCorreo: "Recíbelo por correo",
    introWhatsapp: "Te hemos enviado un código de {largo} dígitos por WhatsApp al",
    enviadoWhatsapp: "Te hemos enviado el código por WhatsApp.",
  },
  langLabel: "Idioma",
  panelTitle: "Todos tus alojamientos automatizados con IA",
  panelDesc: "Check-in, mensajes, llaves, cobros y autoridades. Un solo panel para todo.",

  // Textos
  title: "¡Bienvenido de vuelta!",
  infoTitle: "Si ya tienes una cuenta, ingresa con tu correo.",
  infoDesc: "Si aún no tienes cuenta, puedes registrarte al final.",

  emailLabel: "Email",
  emailPlaceholder: "Introduce tu Email",

  passwordLabel: "Contraseña",
  passwordPlaceholder: "Introduce tu Contraseña",

  forgot: "¿Olvidaste tu contraseña?",

  submit: "Inicia sesión",
  submitting: "Iniciando sesión...",

  noAccount: "¿No tienes una cuenta?",
  signup: "Regístrate",

  // Footer
  terms: "Reglamento",
  privacy: "Política de privacidad",
  copyright: "© 2024–{anio} WA Checkin. Todos los derechos reservados.",

  // Toast / mensajes
  resetSuccess: "Te enviamos un correo para recuperar tu contraseña.",

  errors: {
    default: "Error al iniciar sesión.",
    network: "Error de conexión. Intenta de nuevo.",
  },
  // Reset password modal
  resetPassword: {
    title: "Recuperar contraseña",
    infoTitle: "Te enviaremos un enlace al correo",
    infoDesc:
      "Ingresa tu email y recibirás instrucciones para restablecer tu contraseña.",

    labels: {
      email: "Correo electrónico",
    },

    placeholders: {
      email: "nombre@correo.com",
    },

    hints: {
      email: "Asegúrate de escribir el correo con el que te registraste.",
    },

    buttons: {
      send: "Enviar",
      sending: "Enviando...",
    },

    successTitle: "¡Listo!",
    successDesc: "Revisa tu bandeja de entrada (y spam).",

    aria: {
      close: "cerrar",
    },

    toasts: {
      emailRequired: "Introduce tu email.",
      sent: "Hemos enviado el correo con instrucciones.",
      userNotFound: "Usuario no registrado.",
      networkError: "Error de conexión. Intenta de nuevo.",
    },
  },
  common: {
    ok: "Entendido",
    cancel: "Cerrar",
  },
};
